// extracted by mini-css-extract-plugin
export default {"generalNewsWrapper":"GeneralNews_generalNewsWrapper__W4SYT","generalNewsFeedWrapper":"GeneralNews_generalNewsFeedWrapper__OrYnO"};